// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1151":"d897c785","2319":"d897c785"}[chunkId] + ".chunk.css";
};